import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'
import {COMPONENTS_METADATA} from '@wix/format-converter-schemas'

export const pack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    const componentMetadata = COMPONENTS_METADATA[component.componentType]
    if (!componentMetadata) {
        return
    }

    component.type = componentMetadata.friendlyType
    delete component.componentType
}
